import { apiRequest, retrieveAccessToken } from "./AuthenticationApi";

const blockchainUrl = (
    window.__RUNTIME_CONFIG__?.REACT_APP_API_BLOCKCHAIN ||
    process.env.REACT_APP_API_BLOCKCHAIN ||
    ''
).replace(/^"|"$/g, '').replace(/\/$/, '');


const fetchData = async (url, token) => {
    return apiRequest(url, 'GET', {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
    });
};


export const fetchBlockchainData = async (region, status, lotNumber, gtin) => {
    let code;

    if(region === 'univer') {
        code = 103;
    } else if(region === 'bionet') {
        code = 102;
    }
   
    try {
        const accessToken = retrieveAccessToken();

        // Prepare the main data request URL
        let mainRequestUrl = `${blockchainUrl}/observer/api/events/${code}`;

        const queryParams = new URLSearchParams();
        if (lotNumber) {
            queryParams.append('lotNumber', lotNumber);
        }
        if (status) {
            queryParams.append('eventType', status);
        }
        if (gtin) {
            queryParams.append('gtin', gtin);
        }

        // Add query parameters to the URL if any
        if (queryParams.toString()) {
            mainRequestUrl += `?${queryParams.toString()}`;
        }
        // Post the main data
        const mainResponseData = await fetchData(mainRequestUrl, accessToken);
        return mainResponseData;

    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        return false;
    }
};


export const fetchAssetsData = async (consortiumId, filters = {}) => {
    try {
        const accessToken = retrieveAccessToken();
        if (!accessToken) {
            throw new Error("Token not found. Please log in.");
        }

        // Build base URL
        let url = `${blockchainUrl}/observer/api/asset/${consortiumId}`;

        // Build query parameters like fetchBlockchainData
        const queryParams = new URLSearchParams();

        Object.entries(filters).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                queryParams.append(key, value);
            }
        });

        if (queryParams.toString()) {
            url += `?${queryParams.toString()}`;
        }

        // Execute request
        return await fetchData(url, accessToken);

    } catch (error) {
        console.error('Error fetching asset data:', error);
        return false;
    }
};


export const fetchAssetDetailsData = async (consortiumId, lotNumber) => {
    try {
        const accessToken = retrieveAccessToken();
        if (!accessToken) {
            throw new Error("Token not found. Please log in.");
        }

        // Build base URL
        let url = `${blockchainUrl}/observer/api/asset/${consortiumId}/${lotNumber}`;

        // Execute request
        return await fetchData(url, accessToken);

    } catch (error) {
        console.error('Error fetching asset data:', error);
        return false;
    }
};


export const fetchTraceAssetData = async (consortiumId, lotNumber) => {
    try {
        const accessToken = retrieveAccessToken();
        if (!accessToken) {
            throw new Error("Token not found. Please log in.");
        }

        // Build base URL
        let url = `${blockchainUrl}/observer/api/trace-asset/${consortiumId}/${lotNumber}`;

        // Execute request
        return await fetchData(url, accessToken);

    } catch (error) {
        console.error('Error fetching asset data:', error);
        return false;
    }
};